import React from "react";
import Datetime from "react-datetime";
import moment from "moment-timezone";

const DatetimePicker = ({ field, value, handleChange, readOnly = false }) => {
  const getUserTimezone = () => moment.tz.guess();

  const renderInput = (props) => {
    const timezone = readOnly ? "America/New_York" : getUserTimezone();
    const formattedDate = moment(props.value)
      .tz(timezone)
      .format("MMMM Do YYYY, h:mm A z");

    return (
      <div>
        <input {...props} value={formattedDate} />
      </div>
    );
  };

  return (
    <Datetime
      id={`${field}`}
      name={`${field}`}
      value={value ? new Date(value) : new Date()}
      onChange={handleChange}
      inputProps={{ disabled: readOnly }}
      renderInput={renderInput}
    />
  );
};

export default DatetimePicker;
